import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'Pretendard Variable'`,
    body: `'Pretendard Variable'`,
  },
});

export default theme;
